const imgixUrl = Skubacz.configuration.imgix_url;
export function makeImgUrl(urn) {
    return imgixUrl + urn;
}
export function setQueryParams(params, url) {
    const urlObj = new URL(url);
    Object.entries(params).forEach(([key, value]) => {
        urlObj.searchParams.set(key, value);
    });
    return urlObj.toString();
}
/**
 * Set predefined imgix parameters.
 * Use `setQueryParams` if you need maximum flexibility.
 */
export function adjustImage(params, url) {
    const _params = {
        auto: "compress",
        crop: "focalpoint",
        fit: params.crop ? "crop" : "max",
        h: params.h.toString(),
        w: params.w.toString(),
    };
    return setQueryParams(_params, url);
}
/**
 * Add parameters required for editing text & links to an existing URL
 * The returned URL will have the following parameters set: edit=true&token=X&nocache=1 only
 * if we are alredy in editing mode.
 */
export function withEditingParams(urlPrim) {
    const url = new URL(urlPrim);
    const params = new URLSearchParams(document.location.search);
    const token = params.get("token");
    const edit = params.get("edit");
    if (edit && token) {
        url.searchParams.set("edit", edit);
        url.searchParams.set("token", token);
        url.searchParams.set("nocache", "1");
    }
    return url;
}
